import { getCardFrequencyRank } from "#use-card-frequency-rank";

/**
 * A morpheme nobody is realistically trying to learn: it carries no frequency
 * rank in the reader's script, or it sits in the lowest study tier.
 *
 * Search uses this to decide what goes behind "Show All". The gate used to test
 * `tier === 3` alone, which caught only ~1.6k graphemes while ~24.8k have
 * `tier === null` — so glyphs like 煚/燨/爔/𠓷 (gloss exactly "fire", no
 * frequency data, no tier) sailed into the main grid and, once gloss matches
 * started scoring highest, crowded out 火 and every other real character.
 *
 * The rank must come from {@link getCardFrequencyRank} rather than a hardcoded
 * column: it is script-aware (simplified reads SUBTLEX, traditional reads BIAU),
 * and ~2.2k traditional characters (燒, 爐, 馬 …) have no tier AND no SUBTLEX
 * rank while being genuinely common in traditional script. Keying off `tier` or
 * `subtlexChrRank` alone would bury those for traditional readers.
 */
export function isObscureMorpheme(
  card: Parameters<typeof getCardFrequencyRank>[0] & { tier?: number | null },
  script: "simplified" | "traditional",
): boolean {
  return getCardFrequencyRank(card, script) === null || card.tier === 3;
}
